import './App.css';

import {HashRouter} from "./component/HashRouter";
import {LoginPage} from "./page/LoginPage";
import {RegistrationPage} from "./page/RegistrationPage";
import {AnslagstavlanPage} from "./page/AnslagstavlanPage";
import {ProfilePage} from "./page/ProfilePage";
import {AssignmentPage} from "./page/AssignmentPage";
import {AdminSearchPage} from "./page/AdminSearchPage";
import {AdminProfilePage} from "./page/AdminProfilePage";
import {PasswordResetPage} from "./page/PasswordResetPage";
import {PasswordResetConfirmPage} from "./page/PasswordResetConfirmPage";
import {useEffect} from "react";
import {AdminCompetencesPage} from "./page/AdminCompetencesPage";

function App() {

  // Default route
  useEffect(() => {
    if (!document.location.hash) {
      document.location.hash = "#/login";
    }
  });

  return (
    <div className="App">
      <HashRouter path={"/anslagstavlan"} component={<AnslagstavlanPage/>} />
      <HashRouter path={"/confirm-password-reset"} component={<PasswordResetConfirmPage/>} />
      <HashRouter path={"/login"} component={<LoginPage/>} />
      <HashRouter path={"/password-reset"} component={<PasswordResetPage/>} />
      <HashRouter path={"/profile"} component={<ProfilePage/>} />
      <HashRouter path={"/register"} component={<RegistrationPage/>} />
      <HashRouter path={"/uppdrag"} component={<AssignmentPage/>} />

      <HashRouter path={"/admin-competences"} component={<AdminCompetencesPage/>} />
      <HashRouter path={"/admin-search"} component={<AdminSearchPage/>} />
      <HashRouter path={"/admin-profile/"} component={<AdminProfilePage/>} />
    </div>
  );
}

export default App;
